import { Response } from '@marketplace-web/shared/api-client'

import { GetReturnShippingOptionsResp } from 'types/api/response/get-return-shipping-options-resp'

import { transformReturnShippingOptionDtos } from 'data/transformers/return-shipping-option'
import { transformReturnCurrencyConversionDto } from 'data/transformers/return-currency-conversion'

export const transformGetReturnShippingOptionsResp = (
  response: Response<GetReturnShippingOptionsResp>,
) => ({
  returnShippingOptions: transformReturnShippingOptionDtos(response.return_shipping_options),
  currencyConversion: response.currency_conversion
    ? transformReturnCurrencyConversionDto(response.currency_conversion)
    : null,
})
